import { DriveSection } from '@/drive/types/driveSection';
export var ForwardDestinationType;
(function (ForwardDestinationType) {
    ForwardDestinationType["Collection"] = "collection";
    ForwardDestinationType["Folder"] = "folder";
})(ForwardDestinationType || (ForwardDestinationType = {}));
export function getUniqueDestinationId(destination) {
    if (!destination.id) {
        return DriveSection.DriveRoot;
    }
    return `${destination.type}:${destination.id}`;
}
